import { TableProps } from "antd";
import dayjs from "dayjs";
import { dbTimeFormat } from "../../constants/constants";
import { useGetAttendanceLogQuery } from "../../features/attendanceReport/attendanceReportApi";
import useError from "../../hooks/useError";
import { ModalComponentProps } from "../../types";
import { addKeyInArray } from "../../utils/utils";
import CustomModal from "../ui/CustomModal";
import CustomTable from "../ui/CustomTable";
import Loader from "../ui/Loader";

type ModalType = "LOG" | "IMPORT" | "FILTER" | "REPORT_REQUEST";

const attendanceType = {
  checkin: "Check-in",
  checkout: "Check-out",
};

export default function AttendanceLogModal({
  handleClose,
  data: id,
  ...rest
}: ModalComponentProps<number, ModalType>) {
  const { isLoading, isError, error, data } = useGetAttendanceLogQuery(
    Number(id),
    {
      skip: !id,
    }
  );
  useError(isError, error, "Get attendance log fail");

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Time",
      dataIndex: "time",
      render: (val) =>
        val ? dayjs(val, dbTimeFormat).format("h:mm:ss A") : "-",
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (val: keyof typeof attendanceType) =>
        val ? attendanceType[val] : "-",
    },
    {
      title: "IP",
      dataIndex: "ip",
      render: (val) => val || "-",
    },
    {
      title: "Auto WIFI Attendance",
      dataIndex: "is_auto_wifi_attendance",
      render: (val) => (val ? "Yes" : "No"),
    },
  ];

  return (
    <CustomModal
      title="Attendance Log"
      {...rest}
      handleClose={handleClose}
      width={800}
      footer={null}
    >
      <div className="max-h-[300px] overflow-y-auto">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <CustomTable
              loading={isLoading}
              columns={columns}
              dataSource={addKeyInArray(data?.data?.logs)}
              className="header-table-color"
            />
          </>
        )}
      </div>
    </CustomModal>
  );
}
